import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CheckCircle, ArrowRight, Star, Briefcase, Award } from 'lucide-react';
export function EmbroideryPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-463">
      <Header data-id="element-464" />

      <main className="flex-grow" data-id="element-465">
        {/* Hero */}
        <section className="bg-gradient-to-r from-teal-600 to-emerald-600 text-white py-20 md:py-28" data-id="element-466">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center gap-12" data-id="element-467">
            <div className="md:w-1/2" data-id="element-468">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-469">
                Professional Custom Embroidery
              </h1>
              <p className="text-xl text-teal-100 mb-8 leading-relaxed" data-id="element-470">
                Elevate your brand with high-quality, textured stitching. Ideal
                for hats, polos, jackets, and corporate uniforms that demand a
                premium look.
              </p>
              <a href="/contact" className="inline-flex items-center px-8 py-4 bg-white text-teal-700 font-bold rounded-full shadow-lg hover:bg-gray-50 transition-all transform hover:-translate-y-1" data-id="element-471">
                Request a Quote
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-472" />
              </a>
            </div>
            <div className="md:w-1/2" data-id="element-473">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20" data-id="element-474">
                <div className="space-y-4" data-id="element-475">
                  <div className="flex items-center space-x-3" data-id="element-476">
                    <CheckCircle className="h-6 w-6 text-yellow-300" data-id="element-477" />
                    <span className="text-lg" data-id="element-478">
                      Professional, high-end finish
                    </span>
                  </div>
                  <div className="flex items-center space-x-3" data-id="element-479">
                    <CheckCircle className="h-6 w-6 text-yellow-300" data-id="element-480" />
                    <span className="text-lg" data-id="element-481">
                      Extremely durable & long-lasting
                    </span>
                  </div>
                  <div className="flex items-center space-x-3" data-id="element-482">
                    <CheckCircle className="h-6 w-6 text-yellow-300" data-id="element-483" />
                    <span className="text-lg" data-id="element-484">
                      Perfect for hats & heavy fabrics
                    </span>
                  </div>
                  <div className="flex items-center space-x-3" data-id="element-485">
                    <CheckCircle className="h-6 w-6 text-yellow-300" data-id="element-486" />
                    <span className="text-lg" data-id="element-487">No minimum order quantity</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Use Cases */}
        <section className="py-20" data-id="element-488">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-489">
            <div className="text-center mb-16" data-id="element-490">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-491">
                Perfect For
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-492">
                Embroidery adds a level of sophistication that screen printing
                simply can't match.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-493">
              <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all" data-id="element-494">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-495">
                  <Briefcase className="h-8 w-8 text-teal-600" data-id="element-496" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-497">Corporate Apparel</h3>
                <p className="text-gray-600" data-id="element-498">
                  Polos, button-downs, and jackets with your company logo for a
                  unified, professional team appearance.
                </p>
              </div>
              <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all" data-id="element-499">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-500">
                  <Star className="h-8 w-8 text-teal-600" data-id="element-501" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-502">Hats & Headwear</h3>
                <p className="text-gray-600" data-id="element-503">
                  Structured caps, beanies, and visors. Embroidery is the only
                  way to get a quality design on headwear.
                </p>
              </div>
              <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all" data-id="element-504">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-505">
                  <Award className="h-8 w-8 text-teal-600" data-id="element-506" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-507">Uniforms</h3>
                <p className="text-gray-600" data-id="element-508">
                  Durable branding for medical scrubs, restaurant staff, service
                  technicians, and school uniforms.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-teal-50 py-20" data-id="element-509">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-510">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-511">
              Make a lasting impression
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-512">
              Our state-of-the-art embroidery machines ensure precise, clean
              stitching for every logo. Send us your design today to get
              started.
            </p>
            <a href="/contact" className="inline-flex items-center px-8 py-4 bg-teal-600 hover:bg-teal-700 text-white font-bold rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-513">
              Get a Quote
            </a>
          </div>
        </section>
      </main>

      <Footer data-id="element-514" />
    </div>;
}